<template>
        <div v-if="!error && attribute">
          <div class="card">
            <div class="card-body">
              <AjaxForm :route="'ProductAttribute/Edit/'+id">
                <CustomInput label="عنوان" type="text" name="title" :model-value="attribute.title"></CustomInput>
                <div class="row mt-2">
                  <div class="col-10 col-sm-10 col-md-5 mx-auto">
                    <button class="btn btn-info btn-block" type="submit">ویرایش عنوان</button>
                  </div>
                </div>
              </AjaxForm>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
             <div class="mb-2">
               <h4 class="d-inline-block">مقادیر</h4>&nbsp;
               <button class="btn btn-info btn-sm" @click="addNewValue">افزودن مقدار جدید</button>
             </div>
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                  <tr>
                    <th style="width: 50%;">عنوان</th>
                    <th style="width: 50%;">امکانات</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in items" :key="index">
                    <td>
                      <input type="text" v-model="item.title" name="value" class="form-control" placeholder="مقدار...">
                    </td>
                    <td>
                      <div v-if="item._id" >
                        <button class="btn btn-info" @click="editItemValue($event,index)"><i class="far fa-edit"></i></button>&nbsp;
                        <button class="btn btn-danger" @click="deleteValue(index)"><i class="far fa-trash-can"></i></button>
                      </div>
                      <div v-else>
                        <button  class="btn btn-success" @click="submitNewValue(index)"><i class="far fa-plus"></i></button>&nbsp;
                        <button  class="btn btn-danger" @click="items.splice(index,1)"><i class="far fa-times"></i></button>
                      </div>


                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-danger">
          {{error}}
        </div>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Loading from "@/components/Loading";
import {mapActions} from "vuex";
import CustomInput from "@/components/CustomInput";
import {showSystemNoti} from "@/shared/helper";
import AjaxForm from "@/components/forms/AjaxForm";
import {AppApi} from "@/api/AppApi";
import Swal from "sweetalert2";
export default {
  name: "ProductAttributeEdit",
  components: {CustomInput, Loading,AjaxForm, MasterLayout},
  data(){
    return{
      pageLoaded : true,
      error : false,
      id : this.$route.params.id,
      attribute : null,
      items : []
    }
  },
  mounted()
  {
    this.setPageTitle('ویرایش ویژگی محصول');
    this.setShowHead(true);
    this.initPage();
  },
  methods : {
    ...mapActions('app',{
      getProductAttributeInfo : 'getProductAttributeInfo',
      ProductAttributeAddNewItem : 'ProductAttributeAddNewItem',
      ProductAttributeItemEditTitle : 'ProductAttributeItemEditTitle',
    }),
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
   async initPage()
   {
     this.setPageLoading = true;
     this.id = this.$route.params.id;
     const info = await this.getProductAttributeInfo(this.id);
     if (info)
     {
       if (info.ok)
       {
         this.attribute = info.attribute;
         this.items = info.items;
       }
       else
       {
         this.error = info.error;
       }
     }
     else
     {
       this.error = 'خطا در برقراری ارتباط';
     }
     this.setPageLoading = false;
   },
    async editItemValue(e,index)
    {
      const html = e.target.html;
      console.log(html);
      const item = this.items[index];
      if (!item.title)
        return showSystemNoti('danger','مقدار ویژگی نباید خالی باشد.');
      const result = await this.ProductAttributeItemEditTitle({id : item._id,title : item.title});
      if (result.ok)
        return showSystemNoti('success',result.message);
      else
        return showSystemNoti('danger',result.error);
    },
    addNewValue()
    {
      this.items.push({_id : null,title : ''});
    },
    async submitNewValue(index)
    {
      const item = this.items[index];
      if (item.title)
      {
        const result = await this.ProductAttributeAddNewItem({id : this.attribute._id,title : item.title});
        if (result)
        {
          if (result.ok)
          {
            item._id = result._id;
            return showSystemNoti('success',result.msg)
          }
          else
              return showSystemNoti('danger',result.error);
        }
        else
        {
          return showSystemNoti('danger','خطا در برقراری ارتباط...');
        }
      }
      else
        showSystemNoti('danger','مقدار نباید خالی باشد.');
    },
    async deleteValue(index)
    {
      const item = this.items[index];
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به مقدار ویژگی حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteProductAttributeItem(item._id);
          if (result.ok)
          {
            this.items.splice(index,1);
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })

    }
  }
}
</script>

<style scoped>

</style>